/** @format */

import React from "react";
import { Link } from "react-router-dom";

const BlogLink = () => {
	return (
		<>
			<div className="hidden">
				<div className="col col-lg-6 px">
					<h4 className="text-center font-weight-bold">
						Want to check out my writings?
					</h4>
					<p className="text-center">
						I don&apos;t just write codes. I make sure I put all I
						learnt in the course of building a project into
						documentation, not just to assist me alone, but to also
						help those who are new to that technology to understand
						it more
					</p>
				</div>
				<div className="col col-lg-6 pt-1">
					<p className="text-center">
						Do you want to give my blogs a trial? Click the link
						below and start exploring contenful and understandable
						web articles
					</p>
					<div className="hire-btn">
						<Link to="/blog">
							<button className="btn btn-success">
								Read blogs
							</button>
						</Link>
					</div>
				</div>
			</div>
		</>
	);
};

export default BlogLink;
